import React from 'react';
import { createRoot } from 'react-dom/client';
import '../components/slack/slack.css';
import HeroPoll from '../components/landing/HeroPoll';

let root = null;

document.addEventListener('turbolinks:load', () => {
  const el = document.getElementById('hero-poll-mount');
  if (el) {
    const iconSrc = el.dataset.iconSrc;
    if (root) root.unmount();
    root = createRoot(el);
    root.render(<HeroPoll iconSrc={iconSrc} />);
  }
});
